import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useState } from "react";
import { put } from "../../utils/api";

const DeleteModal = ({
  onOpen,
  onClose,
  url,
  deletedItemId,
  onConfirm,
  title = "Confirm Delete",
  message = "Do you really want to delete this entry?",
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  const PRIMARY_COLOR = "#1C486B";
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleDelete = async () => {
    if (typeof onConfirm === "function") {
      onConfirm();
      return;
    }
    try {
      // onClose();
      // setsnackOpen({
      //   open: true,
      //   message: "Item deleted successfully",
      //   severity: "success",
      // });

      const response = await put(url, { params: { Id: deletedItemId } });
      if (response.response === "Success") {
        onClose();
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      setsnackOpen({
        open: true,
        message: "Failed to delete item",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Dialog
        open={onOpen}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: "377px",
            maxWidth: "92vw",
          },
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "1rem" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{ marginRight: "1rem", color: PRIMARY_COLOR, borderColor: PRIMARY_COLOR }}
          >
            {cancelText}
          </Button>
          <Button
            onClick={handleDelete}
            variant="outlined"
            sx={{
              color:"#fff",
              borderColor: PRIMARY_COLOR,
              backgroundColor: PRIMARY_COLOR,
              "&:hover": {
                backgroundColor: PRIMARY_COLOR,
                color:"#fff",
              },
            }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Move Snackbar outside of Dialog */}
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          severity={snackOpen.severity}
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteModal;
